<script setup lang="ts">
import { ROUTES } from '@configs'
import type { PostsPayload } from '@store'

const route = useRoute()
const { t } = useI18n()
const isLoading = ref(false)
const isError = ref(false)
const postStore = usePostStore()
const searchStore = useSearchStore()
const pageSearchPostRef = ref<HTMLElement>()

// 최초 랜딩시 포스트 목록 조회
onMounted(async () => {
  const { isChanged, newPayload } = checkEqualPostsPayload()
  if (postStore.postsBySearch.items.length && !isChanged) return
  await handleOnFetchPosts(true, newPayload)
})

// 검색어 변경시 포스트 목록 조회
watch(
  () => searchStore.keyword,
  () => {
    handleOnFetchPosts(true)
  }
)

// 포스트 목록 조회 쿼리 비교
const checkEqualPostsPayload = () => {
  const newPayload = {
    searchNttSj: route.query.keyword ? String(route.query.keyword) : '',
  }
  const isChanged =
    newPayload.searchNttSj !== postStore.postsBySearch.payload.searchNttSj

  return { isChanged, newPayload }
}

// 포스트 목록 조회
const handleOnFetchPosts = async (
  refresh = false,
  payload?: Partial<PostsPayload>
) => {
  try {
    isLoading.value = true
    isError.value = false

    await postStore.fetchPosts(
      {
        ...postStore.postsBySearch.payload,
        orderBy: 'newest',
        searchNttSj: searchStore.keyword,
        ...payload,
      },
      refresh,
      'search'
    )
  } catch {
    isError.value = true
  } finally {
    isLoading.value = false
  }
}
</script>

<template>
  <div ref="pageSearchPostRef" class="search-result-post">
    <NovaRecyclerGrid
      v-if="postStore.postsBySearch.items.length"
      :items="postStore.postsBySearch.items"
      :is-last="postStore.postsBySearch.last"
      :is-loading="isLoading"
      :is-error="isError"
      :is-refresh="postStore.postsBySearch.refresh"
      :key-name="'cmtyNttSn'"
      :page-mode="true"
      :error-message="$t('statusMessages.network.error')"
      :responsive="{
        mobile: {
          columns: 1,
          rowGap: 15,
          columnGap: 12,
          padding: { top: 0, right: 10, bottom: 20, left: 10 },
        },
        tablet: { columns: 1, rowGap: 12, columnGap: 12 },
        desktop: {
          columns: 1,
          rowGap: 12,
          columnGap: 12,
        },
      }"
      @load-more="handleOnFetchPosts"
    >
      <template #item="{ item }">
        <NovaBoxPost
          :source="item"
          :view-type="PostContentsType.LIST"
          :list-view-height="'auto'"
          :open-detail-url="
            useRoutePathIdChange(ROUTES.SEARCH_DETAIL_POST.path, {
              id: item.cmtyNttSn,
            })
          "
        />
      </template>
    </NovaRecyclerGrid>

    <NovaBoxEmptyMessage
      v-if="!postStore.postsBySearch.items.length && !isLoading"
      :message="
        t('statusMessages.search.empty', { keyword: searchStore.keyword })
      "
      :fill="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.search-result-post {
  flex-grow: 1;
  //height: 100%;

  @include mobile {
    .posts-list {
      text-align: left;

      :deep(.scroller) {
        padding: 0 10px 20px;
      }

      :deep(.item-wrap) {
        padding-bottom: 15px !important;
      }
    }
  }
}
</style>
